import React, { forwardRef } from 'react';
import { styled, Stack } from '@mui/material';

const CustomStack = styled(Stack)(({ $spacing, theme }) => {
    return {
        gap: theme.spacing($spacing),
    };
});

export default forwardRef(({ spacing = 0, ...rest }, ref) => {
    return <CustomStack ref={ref} $spacing={spacing} {...rest} />;
});
